import React, { useState } from 'react';
import { Box, Hidden, Step, StepLabel, Stepper, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { makeStyles } from 'tss-react/mui';

const SquareStep = styled(Step)({
  backgroundColor: '#f5f5f1',
  maxWidth: '80%',
  '&:first-child': {
    '.MuiStepLabel-iconContainer': {
      svg: {
        backgroundColor: '#97ddcb!important',
        color: '#97ddcb!important'
      }
    }
  },
  '.MuiStepLabel-iconContainer': {
    svg: {
      borderRadius: 0,
      backgroundColor: '#ffffff',
      color: '#ffffff',
      fontWeight: 'bold',
      '&.Mui-active, &.Mui-completed': {
        color: '#97ddcb!important',
        backgroundColor: '#97ddcb!important'
      },
      '&.Mui-completed': {
        color: '#000!important'
      }
    }
  },
  '.MuiStepLabel-label': {
    fontSize: 20,
    fontWeight: 'bold',
    fontFamily: 'Circular Spotify Tx T Bold'
  },
  '.MuiStepContent-root': {
    borderLeft: 0,
    paddingLeft: 0,
    marginLeft: 0
  }
});

const StepperManagement = ({ step }: any) => {
  const useStyles = makeStyles()((theme) => {
    if (activeStep === 2) {
      return {
        line: {
          '.MuiStep-root': {
            [theme.breakpoints.only('sm')]: {
              maxWidth: '95%'
            }
          },
          '&:first-child': {
            '.MuiStepLabel-iconContainer': {
              svg: {
                backgroundColor: '#97ddcb!important',
                color: '#97ddcb!important'
              }
            }
          },
          '.MuiStepLabel-iconContainer': {
            maxHeight: 24
          },
          '.MuiStepConnector-line': {
            borderLeftWidth: 0,
            minHeight: 4
          },
          '.MuiStepLabel-labelContainer': {
            span: {
              color: '#000!important'
            }
          },
          '.MuiStepLabel-label': {
            [theme.breakpoints.down('sm')]: {
              fontSize: '11px!important'
            }
          }
        }
      };
    } else {
      return {
        line: {
          '.MuiStep-root': {
            [theme.breakpoints.only('sm')]: {
              maxWidth: '95%'
            }
          },
          '.MuiStepConnector-line': {
            borderLeftWidth: 0,
            minHeight: 4
          },
          '.MuiStepLabel-labelContainer': {
            span: {
              color: '#000!important'
            }
          },
          '.MuiStepLabel-iconContainer': {
            maxHeight: 24
          },
          '.MuiStepLabel-label': {
            [theme.breakpoints.down('sm')]: {
              fontSize: '11px!important'
            }
          },
          [theme.breakpoints.down('sm')]: {
            '.MuiStepConnector-root': {
              '.MuiStepConnector-line': {
                borderTopStyle: 'dashed'
              },
              '&.Mui-active': {
                '.MuiStepConnector-line': {
                  borderTopStyle: 'solid'
                }
              }
            }
          }
        }
      };
    }
  });

  const [activeStep, setActiveStep] = useState<number>(step);

  const { classes } = useStyles();

  const steps = [
    {
      label: 'Ricerca',
      description: `Inserisci i tuoi date e recupera la tua prenotazione.`
    },
    {
      label: 'Riepilogo',
      description: "Visualizza la prenotazione e controlla l'importo da saldare."
    },
    {
      label: 'Pagamento',
      description: `Effettua il pagamento del saldo con il metodo che più preferisci.`
    }
  ];

  return (
    <>
      <Hidden smDown>
        <Stepper nonLinear activeStep={activeStep} orientation="vertical" className={classes.line}>
          {steps.map((step, index) => (
            <SquareStep key={step.label}>
              <Box p={4}>
                <StepLabel>{step.label}</StepLabel>
                <Typography>{step.description}</Typography>
              </Box>
            </SquareStep>
          ))}
        </Stepper>
      </Hidden>
      <Hidden smUp>
        <Stepper
          nonLinear
          activeStep={activeStep}
          orientation="horizontal"
          className={classes.line}
          alternativeLabel>
          {steps.map((step, index) => (
            <SquareStep key={step.label}>
              <Box>
                <StepLabel>{step.label}</StepLabel>
              </Box>
            </SquareStep>
          ))}
        </Stepper>
      </Hidden>
    </>
  );
};

export default StepperManagement;
